export default "__VITE_ASSET__Bg6Dsh15__"